import { Header, RedocContainer } from './components';
import React from 'react';
import { RedocProvider } from './contexts';

function App() {
    return (
        <RedocProvider>
            <Header />
            <RedocContainer />
        </RedocProvider>
    );
}

export default App;
